import React from 'react';
import { IconProps } from './types';

const AgencyPerformanceIcon: React.FC<IconProps> = props => {
  const { size = 32, fillColor = '#626BFE' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
    >
      <rect width={size} height={size} rx="4" fill={fillColor} />
      <mask id="mask0_4115_7883" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="4" y="4" width="24" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_4115_7883)">
        <path
          d="M7.5 25.7309C7.22386 25.7309 7 25.507 7 25.2309V23.7324C7 23.6077 7.04658 23.4875 7.13062 23.3954L8.13062 22.2992C8.43834 21.9619 9 22.1796 9 22.6362V25.2309C9 25.507 8.77614 25.7309 8.5 25.7309H7.5ZM11.5 25.7309C11.2239 25.7309 11 25.507 11 25.2309V19.3477C11 19.223 11.0466 19.1029 11.1306 19.0107L12.1306 17.9146C12.4383 17.5773 13 17.795 13 18.2516V25.2309C13 25.507 12.7761 25.7309 12.5 25.7309H11.5ZM15.5 25.7309C15.2239 25.7309 15 25.507 15 25.2309V18.2635C15 17.8054 15.5648 17.5885 15.8715 17.9288L16.8715 19.0387C16.9542 19.1305 17 19.2497 17 19.3734V25.2309C17 25.507 16.7761 25.7309 16.5 25.7309H15.5ZM19.5 25.7309C19.2239 25.7309 19 25.507 19 25.2309V19.3751C19 19.2504 19.0466 19.1303 19.1306 19.0381L20.1306 17.942C20.4383 17.6047 21 17.8224 21 18.279V25.2309C21 25.507 20.7761 25.7309 20.5 25.7309H19.5ZM23.5 25.7309C23.2239 25.7309 23 25.507 23 25.2309V14.9631C23 14.8384 23.0466 14.7182 23.1306 14.6261L24.1306 13.5299C24.4383 13.1926 25 13.4103 25 13.8669V25.2309C25 25.507 24.7761 25.7309 24.5 25.7309H23.5ZM7.86938 19.1053C7.56166 19.4426 7 19.2249 7 18.7683V17.1554C7 17.0307 7.04658 16.9105 7.13062 16.8184L13.6306 9.69338C13.8289 9.47602 14.1711 9.47602 14.3694 9.69338L17.6306 13.2682C17.8289 13.4856 18.1711 13.4856 18.3694 13.2682L24.1306 6.95298C24.4383 6.61567 25 6.83337 25 7.28996V8.90285C25 9.02753 24.9534 9.14772 24.8694 9.23983L18.3694 16.3649C18.1711 16.5822 17.8289 16.5822 17.6306 16.3649L14.3694 12.79C14.1711 12.5727 13.8289 12.5727 13.6306 12.79L7.86938 19.1053Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default AgencyPerformanceIcon;
